import FloorContainer from 'components/floor/FloorContainer';

const FloorPage = () => {
  return <FloorContainer />;
};
export default FloorPage;
